import React from 'react';
import './ApprovalManagerRecalled.css'; // Import the CSS file for styles

const ApprovalManagerRecalled = () => {
    return (
        <div className="recalled-time-sheets-container">
            <div className="content-section">
                
                {/* Shorter Question Tag */}
                <h3 style={{ fontSize: "20px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                    How to track and manage recalled timesheets?
                </h3>

                {/* Explanation about Recalled Timesheets */}
                <p className="description">
                    This section helps track "timesheets that have been recalled" by either the "Super Admin" or "Approval Manager" due to issues in the submission. 
                    Employees must review the recall comments, correct the errors, and "resubmit the timesheet" for approval.
                </p>
                
                {/* Step Guide */}
                <h4 className="section-heading">Steps to Process a Recall Request:</h4>
                <ul className="step-guide">
                    <li><strong>Step 1:</strong> Click on "Recall Sheets" if you are logged into the "Super Admin Module" or "Approval Manager Panel".</li>
                    <li><strong>Step 2:</strong> Select the timesheet that needs a recall request and click on the timesheet.</li>
                    <li><strong>Step 3:</strong> Click on "Approved" to process the recall request.</li>
                </ul>

                {/* Recall Request Approval */}
                <h4 className="section-heading">What Happens When a Recall Request is Approved?</h4>
                <ul className="note-points">
                    <li>If the recall request is "approved", the timesheet status changes to "In Progress", meaning it is now in pending sheets.</li>
                    <li>An "email notification" is sent stating that the employee has made a recall request.</li>
                </ul>

                {/* Recall Request Rejection Steps */}
                <h4 className="section-heading">Steps to Reject a Recall Request:</h4>
                <ul className="step-guide">
                    <li><strong>Step 4:</strong> Click on "Recall Sheets" if you are logged into the "Super Admin Module" or "Approval Manager Panel".</li>
                    <li><strong>Step 5:</strong> Select the timesheet that needs a recall request and click on the timesheet.</li>
                    <li><strong>Step 6:</strong> Click on "Rejected" to reject the recall request.</li>
                </ul>

                {/* Recall Request Rejection Effects */}
                <h4 className="section-heading">What Happens When a Recall Request is Rejected?</h4>
                <ul className="note-points">
                    <li>If the recall request is "rejected", the timesheet status changes to "Approved".</li>
                    <li>The rejected recall request "cannot be edited".</li>
                </ul>

                {/* Image Representation */}
                <img
                    className="placeholder-image image_gatnix_support"
                    src="https://res.cloudinary.com/danfpnuui/image/upload/v1737459249/WhatsApp_Image_2025-01-21_at_4.39.59_PM_vsretj.jpg"
                    alt="Recalled Timesheets"
                    style={{ width: "75%", height: "auto", maxWidth: "700px", margin: "20px 0" }} 
                />

                {/* Additional Tips and Notes at the End */}
                <h4 className="section-heading">Tip:</h4>
                <p className="tip-text">
                    Click on "Notifications", select the timesheet status, and click on it. You can "approve or reject" the recall request from here.
                </p>

                <h4 className="section-heading">Additional Tips:</h4>
                <ul className="tip-points">
                    <li>If a "recall request timesheet" is "rejected", it becomes "non-editable".</li>
                </ul>

                <h4 className="section-heading">Note:</h4>
                <ul className="note-points">
                    <li>If you "don’t receive any emails" or face issues, please contact "Gatnix Help Center".</li>
                </ul>

            </div>
        </div>
    );
};

export default ApprovalManagerRecalled;
